<template>
  <div class="thermal-conduction-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Q = k · A · (ΔT/L) · t$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Heat Source -->
          <rect x="20" y="60" width="30" height="120" fill="#ff4757" />
          <text x="25" y="50" fill="#ff4757" font-size="10">热源</text>

          <!-- Medium Bars -->
          <g v-for="(m, i) in materials" :key="i">
             <rect x="50" :y="70 + i*40" width="300" height="20" :fill="m.color" opacity="0.2" />
             <text x="360" :y="85 + i*40" fill="#888" font-size="10">{{ m.name }}</text>
             
             <!-- Gradient Overlay for Temperature -->
             <rect x="50" :y="70 + i*40" :width="m.heatWidth" height="20" fill="url(#heat-grad)" />
          </g>

          <!-- Atom Vibration (Microscopic view of heat) -->
          <g transform="translate(50, 200)">
             <circle v-for="n in 10" :key="'a'+n" :cx="n*30" cy="0" r="4" fill="#888">
                <animateTransform attributeName="transform" type="translate" :values="`0,${-vib(n)}; 0,${vib(n)}; 0,${-vib(n)}`" dur="0.2s" repeatCount="indefinite" />
             </circle>
             <text x="150" y="25" text-anchor="middle" fill="#888" font-size="8">由于原子在平衡位置附近的剧烈振动，能量逐层向右传递</text>
          </g>

          <defs>
            <linearGradient id="heat-grad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#ff4757" />
              <stop offset="100%" stop-color="#ff4757" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>由于材质不同，导热快慢不一</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="danger" size="mini" @click="startHeating">开始加热</el-button>
             <el-button size="mini" @click="reset">冷却</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>热传导是固体主要的传热方式。能量通过微观粒子的**碰撞**和**振动**传递。金属（如铜）含有大量自由电子，所以导热能力远强于非金属（如木材）。导热系数 $k$ 是衡量这一属性的物理量。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThermalConductionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      materials: [
        { name: '铜', k: 1.0, color: '#b87333', heatWidth: 0 },
        { name: '铁', k: 0.4, color: '#aaa', heatWidth: 0 },
        { name: '木', k: 0.05, color: '#8b4513', heatWidth: 0 }
      ],
      timer: null
    }
  },
  methods: {
    vib(n) { return Math.max(0, (11 - n) * 0.5); },
    startHeating() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.materials.forEach(m => {
          if (m.heatWidth < 300) m.heatWidth += m.k * 2;
        });
      }, 50);
    },
    reset() {
      if (this.timer) clearInterval(this.timer);
      this.materials.forEach(m => m.heatWidth = 0);
    }
  },
  beforeDestroy() { if (this.timer) clearInterval(this.timer); }
}
</script>

<style scoped lang="scss">
.thermal-conduction-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
